import {
  Grid,
} from '@xbotvn/mui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import SingleSelect from './SingleSelect';

export default function AddressSelector({
  cities,
  province = '',
  ward = '',
  onAddressChange = () => { },
}) {
  const [address, setAddress] = useState({ province, ward });

  useEffect(() => {
    onAddressChange(address);
  }, [address]);

  const provinceOptions = _.orderBy(_.map(cities, (data, key) => ({ label: data.name, value: key })), ['label'], ['asc']);
  const wardOptions = _.orderBy((_.map(cities?.[province]?.wards || [], (data, key) => ({ label: data.name, value: key }))), ['label'], ['asc']);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <SingleSelect
          options={provinceOptions}
          value={address?.province}
          onChange={(value) => {
            setAddress({ province: value });
          }}
          InputProps={{
            placeholder: 'Chọn tỉnh',
            required: true,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <SingleSelect
          options={wardOptions}
          value={address?.ward}
          onChange={(value) => setAddress((prev) => ({ ...prev, ward: value }))}
          InputProps={{
            placeholder: 'Chọn phường/xã',
            required: true,
          }}
          clearable
        />
      </Grid>
    </Grid>
  );
}

AddressSelector.propTypes = {
  onAddressChange: PropTypes.func,
  cities: PropTypes.shape({}).isRequired,
  province: PropTypes.string,
  ward: PropTypes.string,
};
